/** SVG sparkline — visual only, no data logic */
export default function Sparkline({
  values = [],
  width = 120,
  height = 32,
  stroke = "var(--chart-line)",
  fill = "var(--chart-line)",
  className = "",
}) {
  const nums = values.map((v) => (Number.isFinite(v) ? v : 0));
  if (nums.length < 2) {
    return (
      <svg width={width} height={height} className={`sparkline ${className}`} aria-hidden>
        <line
          x1={0}
          y1={height / 2}
          x2={width}
          y2={height / 2}
          stroke="var(--border-md)"
          strokeWidth={1}
          strokeDasharray="3 3"
        />
      </svg>
    );
  }
  const max = Math.max(1, ...nums.map(Math.abs));
  const min = Math.min(...nums);
  const range = max - min || max;
  const pad = 2;
  const innerW = width - pad * 2;
  const innerH = height - pad * 2;
  const points = nums.map((v, i) => {
    const x = pad + (i / (nums.length - 1)) * innerW;
    const y = pad + innerH - ((v - min) / range) * innerH;
    return `${x},${y}`;
  });
  const linePath = `M ${points.join(" L ")}`;
  const areaPath = `${linePath} L ${pad + innerW},${pad + innerH} L ${pad},${pad + innerH} Z`;

  return (
    <svg width={width} height={height} className={`sparkline ${className}`} aria-hidden>
      <path d={areaPath} fill={fill} fillOpacity={0.12} />
      <path d={linePath} fill="none" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
